// sidebar显示new
export const badgePrefix = 'FansBadgeShowed_';

// 显示粉丝管理上线dialog
export const guidePrefix = 'FansGuideShowed_';

// 显示无效赔付首页上线dialog
export const payDialogPrefix = 'PayDialogShowed_';

// 显示外呼提醒上线dialog
export const callDialogPrefix = 'CallDialogShowed_';

// 显示无效赔付上线dialog
export const payGuidePrefix = 'PayGuideShowed_';

// 显示无效赔付告警条
export const payWarnPrefix = 'PayWarnShowed_';
